<template>
  <Modal :value="visible" @on-cancel="cancel" width="700" :footer-hide="true">
    <div class="pd-20 mg-top10">
      <Carousel v-model="index" v-if="visible" loop>
        <CarouselItem v-for="(item, i) in list" :key="'img'+i">
          <div class="item df_center">
            <img :src="item.file_lnk" class="img" />
          </div>
        </CarouselItem>
      </Carousel>
      <div v-else class="item"></div>
      <div class="btnCtn">
        <Button @click="cancel" type="primary" class="btn">{{ $t('close') }}</Button>
      </div>
    </div>
  </Modal>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    list: Array
  },
  data: function () {
    return {
      index: 0
    }
  },
  methods: {
    ok: function () {
      this.$emit('onClose')
    },
    cancel: function () {
      this.$emit('onClose')
    }
  }
}
</script>

<style scoped>
.item {
  height: 400px;
  margin: 0 1px;
}
.img {
  width: 100%;
  height: 100%;
}
.btn {
  font-size: 14px;
}
.btnCtn {
  margin-top: 20px;
  display: flex;
  justify-content: end;
}
</style>



// WEBPACK FOOTER //
// src/components/myCarouselModal.vue